import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Sidebar";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import StoriesPage from "@/pages/StoriesPage";
import NewStoryPage from "@/pages/NewStoryPage";
import StoryDetailPage from "@/pages/StoryDetailPage";
import ClientsPage from "@/pages/ClientsPage";
import PublicationsPage from "@/pages/PublicationsPage";
import UsersPage from "@/pages/UsersPage";
import PendingAccessPage from "@/pages/PendingAccessPage";
import RejectedAccessPage from "@/pages/RejectedAccessPage";
import MediaPage from "@/pages/MediaPage";
import SiteLauncherPage from "@/pages/SiteLauncherPage";
import LocalAreasPage from "@/pages/LocalAreasPage";
import CompaniesPage from "@/pages/CompaniesPage";
import AIInferencePage from "@/pages/AIInferencePage";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public routes — no auth required */}
          <Route path="/login"    element={<LoginPage />} />
          <Route path="/pending"  element={<PendingAccessPage />} />
          <Route path="/rejected" element={<RejectedAccessPage />} />

          {/* Protected routes — must be logged in + approved */}
          <Route element={<ProtectedRoute />}>
            <Route element={<Layout />}>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard"    element={<DashboardPage />} />
              <Route path="/stories"      element={<StoriesPage />} />
              <Route path="/stories/new"  element={<NewStoryPage />} />
              <Route path="/stories/:id"  element={<StoryDetailPage />} />
              <Route path="/clients"      element={<ClientsPage />} />
              <Route path="/publications" element={<PublicationsPage />} />
              <Route path="/users"        element={<UsersPage />} />
              <Route path="/media" element={<MediaPage />} />
              <Route path="/site-launcher" element={<SiteLauncherPage />} />
              <Route path="/local-areas"   element={<LocalAreasPage />} />
              <Route path="/companies"     element={<CompaniesPage />} />
              <Route path="/ai-inference"  element={<AIInferencePage />} />
            </Route>
          </Route>
        </Routes>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;